// extracted by mini-css-extract-plugin
export var assigneeBadge = "_h6-0";
export var assigneeDetails = "_h6-1";
export var assigneeInfo = "_h6-2";
export var dropdownContainer = "_h6-4";
export var dropdownImage = "_h6-5";
export var editAssigneeInfo = "_h6-3";
export var editAssigneeModalContainer = "_h6-6";
export var hidden = "_h6-8";
export var input = "_h6-7";